import React, { useState } from 'react';

export default function Header() {
  // Check if we're on the homepage or a subpage
  const isHomePage = window.location.pathname === '/';

  // Helper to get the correct href for navigation
  const getNavHref = (anchor) => {
    return isHomePage ? anchor : `/${anchor}`;
  };

  // Mobile nav: the primary nav collapses into a hamburger-toggled dropdown.
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className='am-header'>
      <div className='am-header-bar'>
        <a href={getNavHref('#home')} className='am-logo' aria-label='AM Facilities home' onClick={closeMenu}>
          <img src='/assets/logo.png' alt='AM Facilities logo' />
        </a>
        <button
          type='button'
          className='am-nav-toggle'
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls='am-primary-nav'
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span className={`am-nav-toggle-icon${menuOpen ? ' is-open' : ''}`} aria-hidden='true'>
            <span />
            <span />
            <span />
          </span>
        </button>
        <nav id='am-primary-nav' className={`am-nav${menuOpen ? ' am-nav--open' : ''}`} aria-label='Primary'>
          <a href={getNavHref('#home')} onClick={closeMenu}>Home</a>
          <a href={getNavHref('#how')} onClick={closeMenu}>How it works</a>
          <a href={getNavHref('#services')} onClick={closeMenu}>Our services</a>
          <a href={getNavHref('#about')} onClick={closeMenu}>About us</a>
        </nav>
        <a href="tel:+16476752000" className="am-header-phone" aria-label="Call +1 (647) 675-2000">
          <div className="am-header-phone-icon">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.51 1.51a15.09 15.09 0 01-6.59-6.59l1.51-1.51a.977.977 0 00.24-1.01C8.79 6.43 8.59 5.24 8.59 4.01 8.59 3.45 8.14 3 7.58 3H4.01C3.45 3 3 3.45 3 4.01 3 13.92 11.08 22 20.99 22c.56 0 1.01-.45 1.01-1.01v-3.57c0-.56-.45-1.01-1.01-1.01z" />
            </svg>
          </div>
          <span className="am-header-phone-text">647.675.2000</span>
        </a>
      </div>
      {/* Hidden site title/sub for accessibility only */}
      <h1 className='am-site-title sr-only'>AM Facilities</h1>
      <p className='am-sub sr-only'>Professional cleaning & home inspection services</p>
    </header>
  );
}
